import { isFinite } from 'lodash';
export var recalculateLetterSpacing = function (element, _a) {
    var inheritedFontSize = _a.inheritedFontSize;
    var letterSpacing = parseFloat(element.css('letter-spacing'));
    var fontSizeValue = parseInt(inheritedFontSize, 10);
    if (isFinite(letterSpacing) && isFinite(fontSizeValue)) {
        element.css('letter-spacing', fontSizeValue * letterSpacing + "px");
    }
};
//# sourceMappingURL=recalculate-letter-spacing.js.map